// extracted by mini-css-extract-plugin
module.exports = {"loginSecurityStyleWrapper":"LoginSecurity_loginSecurityStyleWrapper__rHtgb"};